import { SocialMediaType } from "@components/Button/utils/types";
import { IconTypeEnum } from "@components/Icon/utils/types";

export const CARD_WIDTH = 430; // Width of each card in pixels
export const MARGIN = 100; // Margin between cards in pixels
export const CARD_SIZE = CARD_WIDTH + MARGIN; // Total size of each card including margin

export const AUTOPLAY_INTERVAL = 11000; // Interval for autoplay in milliseconds

export const SHARE_PANEL_LIST = [
  {
    text: "Share on WhatsApp",
    whichSocialMedia: SocialMediaType.whatsapp,
    icon: IconTypeEnum.whatsappWhite,
  },
  {
    text: "Share by Email",
    whichSocialMedia: SocialMediaType.email,
    icon: IconTypeEnum.emailWhite,
  },
  {
    text: "Share on X",
    whichSocialMedia: SocialMediaType.twitter,
    icon: IconTypeEnum.twitterWhite,
  },
  {
    text: "Share on Telegram",
    whichSocialMedia: SocialMediaType.telegram,
    icon: IconTypeEnum.telegramWhite,
  },
  {
    text: "Share on Facebook",
    whichSocialMedia: SocialMediaType.facebook,
    icon: IconTypeEnum.facebookWhite,
  },
  {
    text: "Share on LinkedIn",
    whichSocialMedia: SocialMediaType.linkedin,
    icon: IconTypeEnum.linkedinWhite,
  },
];

export const ENDING_SCREEN_CONTENT = [
  {
    emoji: "🎾",
    text: ["You're all set.", " Let's keep it moving."],
  },
  {
    emoji: "👀",
    text: ["You're good to go. ", "Nothing more here."],
  },
  {
    emoji: "🚀",
    text: ["You're all caught up. ", "See you tomorrow."],
  },
  {
    emoji: "🌟",
    text: ["Great job!", "You're all set."],
  },
  {
    emoji: "🔭",
    text: ["Done for the day.", "Stay curious."],
  },
  {
    emoji: "🎉",
    text: ["Celebration time!", "You're all set."],
  },
  {
    emoji: "💡",
    text: ["You've got this.", "See you later!"],
  },
  {
    emoji: "⚡",
    text: ["All done!", "Keep energized."],
  },
  {
    emoji: "🧩",
    text: ["Piece it together.", "Every step counts!"],
  },

  {
    emoji: "📣",
    text: ["You've done it! ", "Great job speaking up!"],
  },
  {
    emoji: "📚",
    text: ["You're gaining knowledge. ", "See you soon!"],
  },
  {
    emoji: "🪴",
    text: ["That's it for today.", "See you tomorrow!"],
  },
];
